/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.PaymentMasterResponseDto>>;
export function request(
  params: API.tms.paymentMaster.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
